import { connect } from "react-redux";
import { RootState } from "types/store";

import FilesPage from "./FilesPage";

const mapState = ({ files }: RootState) => ({
    initFilters: files.filters
});

export default connect(mapState)(FilesPage); 